module.exports = __webpack_public_path__ + "static/media/pic12.7e82eed4.webp";